import isNumber from 'lodash/fp/isNumber'

import type { GalleryImage, MediaProviderTabContentProps } from '../../../types'

import { AllowedMediaSources } from '../../../enums'

export function onGalleryPickHelper(
  onPick: MediaProviderTabContentProps['onPick'],
  provider: AllowedMediaSources,
  setIsLoading: MediaProviderTabContentProps['setIsLoading'],
) {
  return (galleryImage: GalleryImage) => {
    setIsLoading?.(true)

    if (isNumber(galleryImage.width) && isNumber(galleryImage.height)) {
      onPick(galleryImage.src, provider, {
        height: galleryImage.height,
        width: galleryImage.width,
      })

      return
    }

    const image = new Image()

    image.onload = async () => {
      onPick(galleryImage.src, provider, {
        height: image.naturalHeight,
        width: image.naturalWidth,
      })
    }

    image.onerror = () => {
      setIsLoading?.(false)
    }

    image.onabort = () => {
      setIsLoading?.(false)
    }

    image.src = galleryImage.src
  }
}
